import StoreSimpleForm from './StoreSimpleForm'

export default StoreSimpleForm
